<template>
    <div>
        <a @click="showRobotList">个机器人</a>
        <a-modal
        title="查看机器人详情"
        :visible="visibleOfRobotList"
        @ok="handleOk"
        @cancel="handleCancel"
        width=800px
        :footer="null"
        >
            <div class="transferTable" v-show="!displayBot">
                <a-transfer
                    :data-source="mockData"
                    show-search
                    :filter-option="filterOption"
                    :titles="['全部机器人','现有机器人']"
                    :list-style="{
                    width: '300px',
                    height: '400px',
                    }"
                    :operations="['增加机器人', '删除机器人']"
                    :target-keys="targetKeys"
                    :render="item => `${item.nickname}-${item.username  }`"
                    @change="handleChange"
                    :lazy=false
                    >
                    <span slot="notFoundContent">
                        没数据
                    </span>
                    
                </a-transfer>
                <a-button type="primary" class="setButton" @click="batchAddBot()">确定增加和删除!</a-button>
            </div>

            <div v-show="displayBot">
                <div class="changeBot">
                    <a-button class="addBotButton" type="primary" @click="changeBot">增删机器人</a-button>
                </div>
                <div class="search">
                    <a-button type="default" shape="circle" icon="search" @click="showSearch" />
                    <a-input-search class="inputSearch" v-show="displaySearch" v-model="searchText" placeholder="模糊匹配昵称或ID  " style="width: 200px" @search="onSearch" enter-button="Search" />
                </div>
                <br><br>
                <div class="avatar-36-con" v-for="bot in currentList" :key="bot.username">
                    <img class="avatar" :src="bot.avatar_url"/>
                    <div class="nickname">{{bot.nickname + (bot.username ? '（' + bot.username + '）' : '')}}</div>
                    <a-popconfirm @confirm="deleteBotConfirm(clientId, bot.username)" @cancel="deleteBotCancel" okText="删删删" cancelText="不不不">
                        <template slot="title">
                        <p>删除会清空该客户和该机器人的所有关系</p>
                        <p>包括但不仅限于【群关系】，【关键词】，【永久入群设置】等</p>
                        <p>p.s. 此行为将被记录到操作日志</p>
                        </template>
                        <a href="#">
                        <a-icon type='delete' class='editable-cell-icon'/>
                        </a>
                    </a-popconfirm>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import BotChange from './BotChange.vue'
const axios = require('axios')
export default {
    components: { BotChange },
    props: ["text", "clientId", "allBotList"],
    data() {
        return {
            displayBot: true,   // 显示机器人列表（不显示增删机器人的穿梭框）
            visibleOfRobotList: false,  // 是否显示机器人列表的弹窗（点击之后弹窗）
            displaySearch: false,    // 机器人列表页面搜索
            searchText: "",
            searchList: [],
            mockData: [],   // 左边数据
            targetKeys: [],   // 右边数据
            currentList: this.text,  // 在这个列表中增删机器人
            originalList: this.text,  // 保存一下父组件传过来的机器人列表
            batchAddBotUrlPostFix: 'UBot/batch_add_bot',
            unbindBotUrlPostFix: 'UBot/unbind_bot',
            getBotListUrlPostFix: 'UBot/get_bot_list',
        }
    },
    computed: {
        numRobots: function (){
            return this.currentList.length
        },
        batchAddBotUrl: function () {
            return global.DOMAIN + global.API_VERSION + this.batchAddBotUrlPostFix
        },
        unbindBotUrl: function () {
            return global.DOMAIN + global.API_VERSION + this.unbindBotUrlPostFix
        },
        getBotListUrl: function () {
            return global.DOMAIN + global.API_VERSION + this.getBotListUrlPostFix
        },
        
    },
    created() {
        this.prepareDataForTransferTable()
    },
    methods: {
        filterOption(inputValue, option){
        //     console.log("input,option: ", inputValue, option)
        //     return option.username.indexOf(inputValue) > -1 || option.nickname.indexOf(inputValue) > -1;
        // },
        // renderItem(item) {
        //     //  <img style="width: 36px; height: 36px; border-radius: 50%;" src={item.avatar_url}></img>

        //     return h('div', [
        //                 h('img', {style: {
        //                                 width: "30px",
        //                                 verticalAlign: "middle"
        //                             },
        //                             attrs: {
        //                                 src: item.avatar_url
        //                             }
        //                         },)
        //                     ]);
        },
        handleChange(targetKeys, direction, moveKeys) {
            console.log(targetKeys, direction, moveKeys);
            this.targetKeys = targetKeys;
        },
        batchAddBot(){
            console.log("batch add bot")
            const ownedBotUsernameList = []   // 目前已有的机器人
            const batchChangedBots = []   // 通过穿梭框增加的机器人
            const deletedBotsUsernameList = []   // 通过穿梭框删除的机器人

            this.text.forEach(function(item){
                ownedBotUsernameList.push(item.username)
            })
            console.log("ownedBotUsernameList", ownedBotUsernameList)
            this.targetKeys.forEach(function(item){    // 从穿梭框右框中取出以前没有的机器人，添加
                if(ownedBotUsernameList.indexOf(item) == -1){
                    batchChangedBots.push(item)
                }
            })
            this.batchChangedBots = batchChangedBots
            console.log("batchChangedBots", this.batchChangedBots)
            
            if(this.batchChangedBots.length > 0){   // 批量添加机器人
                axios.post(this.batchAddBotUrl, {  
                    bot_username_list: this.batchChangedBots,
                    client_id: this.clientId,
                    token: sessionStorage.token
                })
                .then((data) => {
                    if (data.data.err_code === 0) {
                        console.log('添加机器人成功')
                        window.alert('添加机器人成功')
                    } else if (data.data.err_code === 50002) {
                        console.log('token 不对，跳转登录')
                        this.$router.push('/')
                    }
                    else{
                        console.log(data.data.err_code)
                    }
                })
            }

            var targetKeys = this.targetKeys
            ownedBotUsernameList.forEach(function(item){
                if(targetKeys.indexOf(item) == -1){
                    deletedBotsUsernameList.push(item)
                }
            })
            
            console.log("deletedBotsUsernameList: ", deletedBotsUsernameList)
           
            if(deletedBotsUsernameList.length != 0){  // 批量删除机器人
                for(var index=0; index<deletedBotsUsernameList.length; ++index){
                    this.deleteBot(deletedBotsUsernameList[index])   // 单次删除一个机器人
                }
            }
            this.visibleOfRobotList = false;
            this.displayBot = true;
            this.$emit("refresh", this.targetKeys) // 传到 client-manage 组件，刷新页面 （this.targetKeys 暂时没用）
        },
        deleteBot(botUsername) {
            axios.post(this.unbindBotUrl, {
                    bot_username: botUsername,
                    client_id: this.clientId,
                    token: sessionStorage.token
                }).then((data) => {
                    if(data.data.err_code == 0){
                        console.log("删除机器人： ", botUsername)
                    }
                    else{
                        console.log(data.data.err_code)
                        window.alert("删除机器人： " + botUsername + " 失败")
                    }
                })
        },
        prepareDataForTransferTable() {
        const leftData = []
        const oriTargetData = []
        const owned = []
        this.text.forEach(function(item){
            owned.push(item.username)
        })
        this.allBotList.forEach(function(item){
            leftData.push({
                key: item.username,
                nickname: item.nickname,
                username: item.username,
                title: "title",
                description: "discription",
                disabled: false,
                avatar_url: item.avatar_url
            }) 
            if(owned.indexOf(item.username) != -1){
                oriTargetData.push(item.username)
            }   
        })
        this.mockData = leftData
        this.targetKeys = owned
    },
        showRobotList () {
            this.currentList = this.text
            this.visibleOfRobotList = true;
            this.prepareDataForTransferTable()
        },
        handleOk () { 
            this.visibleOfRobotList = false;
            this.displaySearch = false;
            this.originalList = this.currentList
        },
        handleCancel () {
            this.displayBot = true;
            this.originalList = this.currentList
            this.visibleOfRobotList = false;
            this.displaySearch = false;
            
        },
        deleteBotConfirm (clientId, botUsername) {
            axios.post(this.unbindBotUrl, {
                bot_username: botUsername,
                client_id: clientId,
                token: sessionStorage.token
                })
                .then((data) => {
                if (data.data.err_code === 0) {
                    console.log('删除 Bot 成功')
                    var tempList = []
                    tempList = this.currentList.filter(t => t.username !== botUsername)
                    this.currentList = tempList
                    console.log(this.currentList)
                    this.originalList = this.currentList
                } else if (data.data.err_code === 50002) {
                    console.log('token 不对，跳转登录')
                    this.$router.push('/')
                }
                else{
                    console.log(data.data.err_code)
                }
                })
            var currentList = []
            for(var i=0; i<this.currentList.length; ++i){
                if(this.currentList[i].username == botUsername){
                    continue;
                }
                currentList.push(this.currentList[i])
            }
            this.currentList = currentList
            this.$emit("refresh", this.targetKeys) // 传到 client-manage 组件，刷新页面 （this.targetKeys 暂时没用）
        },
        deleteBotCancel () {
        },
        onSearch (value) {
            this.searchList = [];
            console.log(this.originalList);
            for(var i = 0; i < this.originalList.length; ++i){
                var resNickname;
                resNickname = this.originalList[i].nickname.match(value)
                console.log(resNickname)
                var resUsername;
                resUsername = this.originalList[i].username.match(value)
                var resNicknamePinyin;
                resNicknamePinyin = this.originalList[i].quan_pin.match(value)
                console.log(resNicknamePinyin, resNickname, resUsername)
                if(resNicknamePinyin != null || resNickname != null || resUsername != null){
                    this.searchList.push(this.originalList[i])
                }
            }
            console.log(this.searchList)
            this.currentList = this.searchList;
        },
        showSearch(){
            this.displaySearch = this.displaySearch ^ true;
        },
        changeBot() {
            this.displayBot = false;
        },
        changeCurrentBotList(params){
            this.numRobots = params.length
            this.handleCancel();
        }
    },    
}

</script>
<style>
    .addBotButton{
        position: relative;
        top: 0px;
        width: 500px;
        bottom: 10px;
    }
    .transferTable{
        height: 430px;
    }
    .search{
        float: right;
    }
    .changeBot{
        float: left;
    }
    .setButton{
        position: relative;
        float: left;
        top: 10px;
        width: 690px;
    }

    
</style>
